import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserSubscription } from "../../utils/api/user/user.type";
import { AppStorage } from "../../utils/storage";

const initialState = AppStorage.getItem<UserSubscription>("subscription", {
    data: null,
    loading: false,
    error: null,
});
export const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        onSetSubscription: (state, action: PayloadAction<UserSubscription["data"]>) => {
            state.data = action.payload;
            AppStorage.setItem("subscription", state);
        },
        onSetLoading: (state, action: PayloadAction<UserSubscription["loading"]>) => {
            state.loading = action.payload;
            AppStorage.setItem("subscription", state);
        },
        onSetError: (state, action: PayloadAction<UserSubscription["error"]>) => {
            state.error = action.payload;
            AppStorage.setItem("subscription", state);
        },
        clearSubscription: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null
            AppStorage.setItem("subscription", state);
        },
    },
});

export const { onSetLoading, onSetSubscription, clearSubscription, onSetError } =
    subscriptionSlice.actions;
export default subscriptionSlice.reducer;
